import React from 'react'
import { Modal as ReactStrapModal, ModalProps as ReactStrapModalProps } from 'reactstrap'

export const Modal = (props: ReactStrapModalProps) => <ReactStrapModal {...props} />
